import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'how_does_the_fac_engage_w_wrkrs_to_proactively_seek_suggestions'

export const dataPointDefinition = {
  retracedId: 'how_does_the_fac_engage_w_wrkrs_to_proactively_seek_suggestions',
  name: 'How does the facility engage with workers to proactively seek suggestions and feedback?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'PHONE_HOTLINES',
      text: 'Phone Hotlines',
      externalIds: [
        {
          id: 'ef-1-1x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WEBSITE_FORMS',
      text: 'Website Forms',
      externalIds: [
        {
          id: 'ef-1-2x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'SURVEYS_IN_PERSON_OR_ONLINE_',
      text: 'Surveys (in-person or online)',
      externalIds: [
        {
          id: 'ef-1-3x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'TEAM_MEETINGS',
      text: 'Team Meetings',
      externalIds: [
        {
          id: 'ef-1-4x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'COMPANY_TOWN_HALLS',
      text: 'Company Town Halls',
      externalIds: [
        {
          id: 'ef-1-5x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'ef-1-6x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'ef-1-7x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'PHONE_HOTLINES',
                'WEBSITE_FORMS',
                'SURVEYS_IN_PERSON_OR_ONLINE_',
                'TEAM_MEETINGS',
                'COMPANY_TOWN_HALLS',
                'OTHER',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wi-work-1',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 13210,
  sectionId: '2.2.10.2',
  impactArea: 'Workplace Cooperation',
  impactAreaId: 'WORKPLACE_COOPERATION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
